import { createContext } from "react";

export const ActionsContext = createContext();
